import { Flex } from '@qga/roo-ui/components';
import {
  CardWrapper,
  CardImage,
  InfoWrapper,
  Heading,
  SubHeading,
  StayInfo,
  CancellationLabel,
  DepositPayReminder,
  Hr,
  ItemLinks,
} from '../Components';
import { generateViewBookingDetailsItemLink, generateActionItemLinks } from './utils';
import { useBookingList } from 'pages/BookingListPage/BookingListProvider';
import { SelfServiceAPI } from 'types';
import BookingStatus from './components/BookingStatus';

interface UpcomingBookingCardProps {
  booking: SelfServiceAPI.UpcomingBooking;
  [key: string]: any;
}

const UpcomingBookingCard = ({ booking, trackViewBookingItem, ...rest }: UpcomingBookingCardProps) => {
  const { sendViewBookingEvent } = useBookingList();

  const {
    id,
    mediumImage,
    reservation: { property },
  } = booking;

  const track = () => sendViewBookingEvent(id);
  const detailsLink = generateViewBookingDetailsItemLink(booking, track);
  const itemLinks = generateActionItemLinks(booking, track);

  return (
    <CardWrapper>
      <CardImage {...mediumImage} link={detailsLink} onClick={track} />

      <InfoWrapper bookingId={booking.id} {...rest}>
        <BookingStatus booking={booking} />

        <Heading>{property.name}</Heading>
        <SubHeading>{property.address.suburb}</SubHeading>

        <StayInfo booking={booking} />

        <Flex flexDirection={['column', 'row']} mb={[0, 4]}>
          <CancellationLabel booking={booking} />
          <DepositPayReminder booking={booking} />
        </Flex>
      </InfoWrapper>
      <Hr />
      <ItemLinks links={itemLinks} />
    </CardWrapper>
  );
};

UpcomingBookingCard.displayName = 'UpcomingBookingCard';

export { UpcomingBookingCard };
